<script>
import Layout from '@layout/main'

export default {
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  methods: {
    goToBack() {
      this.$router.go(-1);
    }
  },
}
</script>

<!-- section template -->
<template>
  <Layout>
    <section class="section text-center">
      <div class="container--callback">
        <img
          v-if="!$globalIsDingBeauty"
          alt="404"
          src="@assets/images/default/404.svg"
          class="mb-5"
        >
        <img
          v-else
          alt="404"
          src="@assets/images/dingbeauty/default/404.svg"
          class="mb-5"
        >
        <div class="mb-5">
          <h1 class="fs-lg fw-semi-bold mb-2">
            Error 404 頁面連結錯誤
          </h1>
          <p class="text-gray-2 fs-sm lh-lg">
            很抱歉！目前無法連結到該頁面。
            <br>造成您的不便，敬請見諒。
          </p>
        </div>
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-md">
            <BaseButton
              class=" isOutline3 isFull"
              :class="{ 'isStylePrimary isRadius': !$globalIsDingBeauty,
              'isStyleSecondary': $globalIsDingBeauty }"
              @click="goToBack"
            >
              回上頁
            </BaseButton>
          </div>
          <div class="col-md mb-3 mb-md-0">
            <BaseButton
              class="isStylePrimary isFull"
              :class="{ 'isRadius': $globalIsJtails }"
              :to="{ name: 'home' }"
            >
              回首頁
            </BaseButton>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>
